import { jsx as _jsx } from "react/jsx-runtime";
import { getValidRgbaColor } from "../../helpers/rbg";
const checkerSize = 9.1;
const checkerColor = "#E3E3E3";
const swatchBg = {
    backgroundColor: "#BBBBBB",
    backgroundImage: `linear-gradient(45deg, ${checkerColor} 25%, transparent 25%), linear-gradient(-45deg, ${checkerColor} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${checkerColor} 75%), linear-gradient(-45deg, transparent 75%, ${checkerColor} 75%)`,
    backgroundSize: `${checkerSize}px ${checkerSize}px`,
    backgroundPosition: `0 0, 0 ${checkerSize / 2}px, ${checkerSize / 2}px -${checkerSize / 2}px, -${checkerSize / 2}px 0px`
};
export const Swatch = ({ color, isDyanamic, onClick })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "!cursor-pointer w-[22px] h-[22px] relative rounded-[3px] overflow-hidden",
        style: {
            ...swatchBg
        },
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full h-full",
            style: {
                background: getValidRgbaColor(color) ? color : `rgba(0, 0, 0, 0)`
            }
        })
    });
};
